/*
 * Registers the Agents page and its sidebar link.
 *
 * `PageBlueprint` is the documented extension for a routable page, and the module declares
 * `pluginId: 'app'` like the theme and Guide modules. `oss_apps/backstage` is untouched; the
 * scaffolded app gains one import.
 */
import { createFrontendModule, PageBlueprint } from '@backstage/frontend-plugin-api';

export const AGENTS_PATH = '/agents';

const agentsPage = PageBlueprint.make({
  name: 'stackschematic-agents',
  params: {
    path: AGENTS_PATH,
    loader: async () => {
      const { AgentsPage } = await import('./AgentsPage');
      return <AgentsPage />;
    },
  },
});

export const stackSchematicFleetModule = createFrontendModule({
  pluginId: 'app',
  extensions: [agentsPage],
});
